import { Base_Url } from "../../BaseURL/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithAuthorization,
} from "../ApiMethods/ApiMethod";

const DesignationUrl = `${Base_Url}/SADesignation`;

export const GetSADesignationList = async (params) => {
  const res = await postApiWithAuthorization(
    `${DesignationUrl}/GetSADesignationList`,
    params
  );
  return res;
};

export const AddUpdateSADesignation = async (params) => {
  const res = await postApiWithAuthorization(
    `${DesignationUrl}/AddUpdateSADesignation?ModuleName=${params.ModuleName}`,
    params
  );
  return res;
};
export const GetSADesignationModel = async (ModuleName, KeyID, adminKeyID) => {
  const res = await getApiWithAuthorization(
    `${DesignationUrl}/GetSADesignationModel?ModuleName=${ModuleName}&adminKeyID=${adminKeyID}&DesignationKeyID=${KeyID}`
  );
  return res;
};

export const ChangeSADesignationStatus = async (
  ModuleName,
  KeyID,
  adminKeyID
) => {
  const res = await getApiWithAuthorization(
    `${DesignationUrl}/ChangeSADesignationStatus?ModuleName=${ModuleName}&adminKeyID=${adminKeyID}&DesignationKeyID=${KeyID}`
  );
  return res;
};

export const DeleteSADesignation = async (ModuleName, KeyID, adminKeyID) => {
  const res = await getApiWithAuthorization(
    `${DesignationUrl}/DeleteSADesignation?ModuleName=${ModuleName}&adminKeyID=${adminKeyID}&DesignationKeyID=${KeyID}`
  );
  return res;
};

export const GetSADesignationLookupList = async (adminKeyID) => {
  const res = await getApiWithAuthorization(
    `${DesignationUrl}/GetSADesignationLookupList?adminKeyID=${adminKeyID}`
  );
  return res;
};
